<template>
  <div v-if="value">
    <div class="modal-overlay"></div>
    <div class="modal-container">
      <h3 v-text="this.message.title.toString()"></h3>
      <div v-html="this.message.text.toString()"></div>
      <div class="modal-buttons">
        <button type="button" class="button medium-button" id="dismiss-custom-message" @click="dismiss">OK</button>
      </div>
    </div>
  </div>
</template>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}

.modal-buttons {
  padding-top: 20px;
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    message: Object,
    value: Boolean,
  },

  beforeDestroy() {
    
  },

  methods: {
    dismiss() {
      this.$emit('input', false);
      const today = new Date();
      localStorage.setItem(this.message.key.toString(), today.toISOString());
      this.$emit('notify');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/CustomMessageModal.vue